import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, useMediaQuery } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { sendRequest, serviceList } from 'src/utils';
import ButtonAction from '../Button.js/SaveButton';
import ComboBox from '../Input/ComboBox';
import TextInput from '../Input/TextInput';
import Loader from '../loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const dataTimeZone = [
    {
        country: 'Việt Nam',
        time_zone: 'Asia/Ho_Chi_Minh',
        offset_utc: '+07:00',
        offset_seconds: 25200,
        abbreviation: 'ICT',
    },
    {
        country: 'Japan (Tokyo)',
        time_zone: 'Asia/Tokyo',
        offset_utc: '+09:00',
        offset_seconds: 32400,
        abbreviation: 'JST',
    },
    {
        country: 'USA (New York - EST)',
        time_zone: 'America/New_York',
        offset_utc: '-05:00',
        offset_seconds: -18000,
        abbreviation: 'EST',
    },
    {
        country: 'USA (New York - EDT)',
        time_zone: 'America/New_York',
        offset_utc: '-04:00',
        offset_seconds: -14400,
        abbreviation: 'EDT',
    },
    {
        country: 'USA (Los Angeles - PST)',
        time_zone: 'America/Los_Angeles',
        offset_utc: '-08:00',
        offset_seconds: -28800,
        abbreviation: 'PST',
    },
    {
        country: 'USA (Los Angeles - PDT)',
        time_zone: 'America/Los_Angeles',
        offset_utc: '-07:00',
        offset_seconds: -25200,
        abbreviation: 'PDT',
    },
    {
        country: 'USA (Chicago - CST)',
        time_zone: 'America/Chicago',
        offset_utc: '-06:00',
        offset_seconds: -21600,
        abbreviation: 'CST',
    },
    {
        country: 'USA (Chicago - CDT)',
        time_zone: 'America/Chicago',
        offset_utc: '-05:00',
        offset_seconds: -18000,
        abbreviation: 'CDT',
    },
    {
        country: 'USA (Denver - MST)',
        time_zone: 'America/Denver',
        offset_utc: '-07:00',
        offset_seconds: -25200,
        abbreviation: 'MST',
    },
    {
        country: 'USA (Denver - MDT)',
        time_zone: 'America/Denver',
        offset_utc: '-06:00',
        offset_seconds: -21600,
        abbreviation: 'MDT',
    },
];

const data_currency = [
    { label: 'VND', value: 'VND' },
    { label: 'USD', value: 'USD' },
    { label: 'JPY', value: 'JPY' },
];
const CreateUserAdminModal = ({ visible = false, dataUpdate, setVisible, fuctGet, isEdit, fuctGetById }) => {
    const { t } = useTranslation();
    const [flagAddStat, setFlagAddStat] = useState(false);
    const addFlag = useRef(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [departments, setDepartments] = useState([]);
    const [department, setDepartment] = useState(null);
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');

    const [email, setemail] = useState('');
    const [phone, setPhone] = useState('');
    const [username, setUsername] = useState('');
    const [RFIDCode, setRFIDCode] = useState('');
    const [currency, setCurrency] = useState('');
    const departmentRef = useRef([]);
    const getRef = useRef(false);
    const [timeZone, setTimeZone] = useState({
        ...dataTimeZone[0],
        country: dataTimeZone[0].country + ' ' + dataTimeZone[0].offset_utc,
    });

    React.useEffect(() => {
        setTimeout(() => {
            getDataDepartment();
        }, 1000);
    }, []);

    useEffect(() => {
        console.log('dataUpdate: ', dataUpdate);

        if (isEdit) {
            setTimeZone({
                country: dataUpdate?.country_time_zone,
                time_zone: dataUpdate?.time_zone,
                offset_utc: dataUpdate?.offset_utc,
                offset_seconds: dataUpdate?.offset_seconds,
                abbreviation: dataUpdate?.abbreviation,
            });
            setName(dataUpdate.user_nm);
            setUsername(dataUpdate.accounts);
            setPhone(dataUpdate.phone);
            setemail(dataUpdate.email);
            setCurrency(dataUpdate.currency);
            console.log(dataUpdate);
            setDepartment({
                departs_nm: dataUpdate.departs_nm,
                id: dataUpdate.department_id,
            });
            const filterDeopart = departmentRef.current.filter((item) => item.group_user === dataUpdate.group_user);
            setDepartments(filterDeopart);
            setRFIDCode(dataUpdate.code_rfid || '');
        } else {
            setName('');
            setUsername('');
            setRFIDCode('');
            setPhone('');
            setemail('');
            setPassword('');
            setDepartment({});
            setDepartments(departmentRef.current);
        }
    }, [dataUpdate]);

    const getDataDepartment = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = ['1'];
        sendRequest(
            serviceList.get_by_group_level,
            InVal,
            getDataResultDepartment,
            true,
            timeOutFunctDepartment,
            40000
        );
    }, []);

    const getDataResultDepartment = (reqInfoMap, message) => {
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDepartments(message.proc_data.rows[0].o_1);
            departmentRef.current = message.proc_data.rows[0].o_1;
        }
    };

    const timeOutFunctDepartment = (reqInfo) => {
        getRef.current = false;
        toast.error(t('error.time_out'));
    };
    const handleEdit = () => {
        if (addFlag.current === true) return;
        if (!name || !username || !department || !timeZone || !currency) return toast.error(t('error.param'));
        if (!isEdit) {
            if (!password || password.trim() === ' ') {
                toast.error(t('error.pass'));
                return;
            }
        }
        
        addFlag.current = true;
        setFlagAddStat(true);

        if (isEdit) {
            const InVal = [name, username, email, phone, dataUpdate.id, RFIDCode, timeZone, currency];

            sendRequest(serviceList.update_admin, InVal, actionResult, true, timeOutFunct, 40000);
        } else {
            const InVal = [name, username, email, phone, department.id, btoa(password), RFIDCode, timeZone, currency];

            sendRequest(serviceList.createstaff, InVal, actionResult, true, timeOutFunct, 40000);
        }
    };

    const actionResult = (reqInfoMap, message) => {
        addFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            if (isEdit) {
                fuctGetById && fuctGetById(dataUpdate.id);
            } else {
                fuctGet && fuctGet();
            }
            setVisible(!visible);
        }
    };

    const timeOutFunct = (reqInfo) => {
        addFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out'));
    };

    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {!isEdit ? t('create_user') : t('update_user')}
            </BootstrapDialogTitle>
            <Loader loading={flagAddStat} />
            <DialogContent dividers>
                <Grid padding={'8px 0'} container spacing={2}>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <TextInput label={t('name_staff')} valueChange={name} getValue={setName} required autoFocus />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <TextInput
                            label={t('username')}
                            valueChange={username.toLocaleLowerCase()}
                            required
                            getValue={setUsername}
                        />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <TextInput
                            label={t('password')}
                            type="password"
                            disabled={isEdit}
                            valueChange={password}
                            required
                            getValue={setPassword}
                        />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <TextInput label={t('phone_supplier')} valueChange={phone} getValue={setPhone} />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <TextInput label={t('Email')} valueChange={email} getValue={setemail} />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <ComboBox
                            label={t('department')}
                            valueSelect={department}
                            displayLabel="departs_nm"
                            valueEqual="id"
                            getValue={setDepartment}
                            selectOption={departments}
                            required
                        />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <ComboBox
                            label={t('currency')}
                            valueSelect={data_currency.find((ele) => ele.value === currency)}
                            displayLabel="label"
                            valueEqual="value"
                            getValue={(e) => {
                                console.log(e);
                                setCurrency(e?.value);
                            }}
                            selectOption={data_currency}
                            required
                        />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <ComboBox
                            label={t('timeZone')}
                            valueSelect={timeZone}
                            displayLabel="country"
                            valueEqual="id"
                            getValue={(e) => {
                                console.log(e);
                                setTimeZone(e);
                            }}
                            selectOption={dataTimeZone.map((row, index) => {
                                return {
                                    ...row,
                                    id: index,
                                    country: row['country'] + ' ' + row['offset_utc'],
                                };
                            })}
                            required
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction onClick={() => setVisible(!visible)} type={'cancel'} title={t('cancel')} />

                <ButtonAction onClick={handleEdit} type={'save'} title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default CreateUserAdminModal;
